/**
 * 获公共属性,包括动态属性
 * @param commonParams
 */

export default function getCurCommonParams(commonParams: any) {
  if (!commonParams) return {};

  const params = {};
  Object.keys(commonParams).forEach((key) => {
    if (commonParams[key] && typeof commonParams[key] === 'function') {
      // @ts-ignore
      params[key] = commonParams[key]!.call(commonParams);
    } else {
      // @ts-ignore
      params[key] = commonParams[key];
    }
  });

  return params;
}
